import { useMemo } from "react";

import { useObjectMemo, modules } from "byzantine";

import getLimitsForDisplay from "../../../../../../../../components/transfer/limitsForDisplay";

export const useDetailsSelector = () => {
  const { wireReasons } = modules.wireTemplates.useData();

  const form = modules.wireTemplates.sendViaTemplateForm.useForm();

  const {
    values: { method },
  } = modules.wireTemplates.methodSelectorForm.useForm();

  return useObjectMemo({
    wireReasons,
    method,
    form,
  });
};

export const useLimitsForDisplay = (limits: API.Limits.ByType) => {
  return useMemo(
    () => getLimitsForDisplay(limits, ["wire", "organization_user_wire"]),
    [limits]
  );
};
